export interface ApiSuccess<T> {
  ok: true;
  message: string;
  data: T;
}

export interface ApiFailure {
  ok: false;
  message: string;
  error: { code: string; message: string; details?: unknown };
}

export type ApiResponse<T> = ApiSuccess<T> | ApiFailure;

const API_BASE = (import.meta.env.VITE_API_BASE_URL || "/api").replace(/\/$/, "");
const TOKEN_KEY = import.meta.env.MODE === "bo" ? "sodamwon-bo-token" : "sodamwon-fo-token";

export function getApiToken() {
  return sessionStorage.getItem(TOKEN_KEY) || "";
}

export function setApiToken(token: string) {
  if (token) sessionStorage.setItem(TOKEN_KEY, token);
  else sessionStorage.removeItem(TOKEN_KEY);
}

export async function requestApi<T>(path: string, init?: RequestInit): Promise<T> {
  const token = getApiToken();
  const isFormData = init?.body instanceof FormData;
  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    cache: init?.cache || "no-store",
    headers: {
      ...(!isFormData ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...init?.headers,
    }
  });
  const payload = (await response.json()) as ApiResponse<T>;
  if (!response.ok || !payload.ok) throw new Error(payload.message || "요청을 처리할 수 없습니다.");
  return payload.data;
}
